import UserEvent from "../../event/UserEvent"
import { Properties } from "../../model/model"
import { Clock } from "../../util/TimeUtil"
import EvaluateResponse from "../EvaluateResponse"
import Evaluation from "../Evaluation"
import ExperimentEvaluation from "../service/experiment/ExperimentEvaluation"
import RemoteConfigEvaluation from "../service/remoteconfig/RemoteConfigEvaluation"

export default class EvaluationEventFactory {
  private static readonly ROOT_TYPE = "$targetingRootType"
  private static readonly ROOT_ID = "$targetingRootId"
  private static readonly CONFIG_ID = "$parameterConfigurationId"
  private static readonly EXPERIMENT_VERSION = "$experiment_version"
  private static readonly EXECUTION_VERSION = "$execution_version"

  constructor(private readonly clock: Clock) {}

  create(response: EvaluateResponse): UserEvent[] {
    const timestamp = this.clock.currentMillis()
    const events: UserEvent[] = []
    const rootEvent = this.createEvent(response, response.evaluation, timestamp, {})
    if (rootEvent !== null) {
      events.push(rootEvent)
    }

    response.references.forEach((reference) => {
      const properties: Properties = {
        [EvaluationEventFactory.ROOT_TYPE]: response.evaluation.entity.serviceType,
        [EvaluationEventFactory.ROOT_ID]: response.evaluation.entity.id
      }
      const event = this.createEvent(response, reference, timestamp, properties)
      if (event !== null) {
        events.push(event)
      }
    })
    return events
  }

  private createEvent(
    response: EvaluateResponse,
    evaluation: Evaluation,
    timestamp: number,
    properties: Properties
  ): UserEvent | null {
    if (evaluation instanceof ExperimentEvaluation) {
      const parameterConfigurationId = evaluation.result.variation.config?.id
      if (parameterConfigurationId !== undefined) {
        properties[EvaluationEventFactory.CONFIG_ID] = parameterConfigurationId
      }
      properties[EvaluationEventFactory.EXPERIMENT_VERSION] = evaluation.entity.version
      properties[EvaluationEventFactory.EXECUTION_VERSION] = evaluation.entity.executionVersion
      return UserEvent.exposure(timestamp, response.user, response.workspace, evaluation, properties)
    }

    if (evaluation instanceof RemoteConfigEvaluation) {
      return UserEvent.remoteConfig(timestamp, response.user, response.workspace, evaluation, properties)
    }

    return null
  }
}
